import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

// Where "here" points: the AI Credits and Billing help article.
const AI_CREDITS_BILLING_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/31154048227740-AI-Credits-and-Billing';

const Notice = styled.small`
    display: block;
    margin-top: 6px;
    font-size: 11px;
    font-style: italic;
    line-height: 1.4;
    color: ${(props) => props.theme.app.component.icon.button.default.color};
`;

const NoticeLink = styled.a`
    color: ${(props) => props.theme.ai.solid};
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
`;

// Small print shown under AI prompt fields: AI features may consume credits.
export const AiCreditsNotice: FC = () => (
    <Notice>
        {T._(
            'AI features consume credits. A free credit pack is provided initially; additional usage is billed once it runs out, although some operations remain free. See',
            'Admin'
        )}{' '}
        <NoticeLink href={AI_CREDITS_BILLING_URL} target='_blank' rel='noopener noreferrer'>
            {T._('here', 'Admin')}
        </NoticeLink>
        .
    </Notice>
);

export default AiCreditsNotice;
